import * as moment_ from 'moment';

import {Observable} from 'rxjs';
import {of} from 'rxjs/internal/observable/of';

import {HttpStatusCodes} from '../enums';

import {ApiError} from './api-error';
import {ApiResponse} from './api-response';
import {ServerResponseData} from '../types';

const moment = moment_;

// @dynamic
export class Helper {
    static formatDate(
        date: string | number | Date,
        dateFormatType: string = 'MM/DD/YY',
        toUTC: boolean = false
    ): string {
        const formatted = !toUTC ? moment(date) : moment(date).utc();

        if (!formatted.isValid()) {
            return '';
        }

        return formatted.format(dateFormatType);
    }

    static getDefaultDateFormat(): string {
        return 'MM/dd/yy';
    }

    static modelFactory<T, U>(construct: new(item: T) => U, dataInterface: T): U {
        return new construct(dataInterface);
    }

    static collectionFactory<T, U>(construct: new(item: T) => U, collection: T[]): U[] {
        return collection.map((collectionItem: T) => {
            return new construct(collectionItem);
        });
    }

    static createSuccessResponse<DataType>(data: DataType): ApiResponse<DataType> {
        return new ApiResponse<DataType>(HttpStatusCodes.Ok, data);
    }

    static createSuccessResponseObservable<DataType>(data: DataType): Observable<ApiResponse<DataType>> {
        const response = new ApiResponse<DataType>(HttpStatusCodes.Ok, data);

        return of(response);
    }

    static createErrorResponse<DataType>(
        response: ApiResponse<ApiError[] | DataType>,
        errorState?: number
    ): ApiResponse<ApiError[]> {
        let errorData = [];

        if (typeof errorState !== 'undefined') {
            const apiError = new ApiError(errorState);

            errorData.push(apiError);
        } else {
            errorData = response.data as ApiError[];
        }

        return new ApiResponse<ApiError[]>(response.status, errorData, response.messages);
    }

    static createBadRequestResponse(): ApiResponse<ApiError[]> {
        const error = new ApiError(HttpStatusCodes.BadRequest);

        return new ApiResponse(HttpStatusCodes.BadRequest, [error]);
    }

    static createResponseForNoDataObservable(): Observable<ApiResponse<ApiError[]>> {
        return of(Helper.createResponseForNoData());
    }

    static createResponseForNoData(): ApiResponse<ApiError[]> {
        const data = new ApiError();

        data.data = 'Not Found';
        data.status = HttpStatusCodes.NotFound;

        return new ApiResponse(HttpStatusCodes.NotFound, [data], ['Not Found']);
    }

    static fixToFloat(value: number, toFixed: number = 2): number {
        const nullableValue = parseInt('0', 10).toFixed(toFixed);

        if (!value) {
            return parseFloat(nullableValue);
        }

        const isNegativeValue = value < 0;

        // If the exp is undefined or zero...
        if (+toFixed === 0) {
            return Math.round(value);
        }

        value = Math.abs(value);
        toFixed = -toFixed;

        // If the value is not a number or the exp is not an integer...
        if (!((typeof toFixed === 'number') && (toFixed % 1 === 0))) {
            return parseFloat(nullableValue);
        }

        let toStringArrayValue = value.toString().split('e');

        value = Math.round(+(toStringArrayValue[0] + 'e' + (toStringArrayValue[1] ? (+toStringArrayValue[1] - toFixed) : -toFixed)));

        toStringArrayValue = value.toString().split('e');

        value = +(toStringArrayValue[0] + 'e' + (toStringArrayValue[1] ? (+toStringArrayValue[1] + toFixed) : toFixed));

        return !isNegativeValue ? value : -value;
    }

    static checkForInvalidRespondedArray<DataType>(response: ServerResponseData<DataType[]>): boolean {
        return (!Array.isArray(response.data) || ((Array.isArray(response.data) && response.data.length === 0)));
    }
}
